import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {DxDataGridComponent} from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import {dxDataGridColumn} from 'devextreme/ui/data_grid';
import {DOMService, ScreenService} from '../../../../shared/services/general';

@Component({
  selector: 'app-glass',
  templateUrl: './glass.component.html',
  styleUrls: ['./glass.component.scss'],
})
export class GlassComponent implements OnChanges, OnInit {
  @Input() public mode: 'single' | 'multiple' = 'single';
  @Input() public keyExpr: string = 'id';
  @Input() public displayExpr: string | Function = '';
  @Input() public label: string = '';
  @Input() public placeholder = 'Select an item...';
  @Input() public arr: any;
  @Input() public disabled = false;
  @Input() public selectedItemsKeys?: any[] = [];
  @Input() public selectedItemsRowsOnlyEdit?: any[] = [];
  @Input() public disableInEdit = false;
  @Input() public selectedItemNoAccess: any[] = [];
  @Input() public columns?: Array<dxDataGridColumn | string> = [];
  @Input() public dropDownColumns?: Array<dxDataGridColumn | string> = [];
  @ViewChild('container', {static: true}) public containerDiv?: ElementRef;
  @ViewChild('controls', {static: true}) public controlsDiv?: ElementRef;
  @ViewChild('grid', {static: true}) public grid?: DxDataGridComponent;
  @ViewChild('dropDownGrid', {static: false}) public dropDownGrid?: DxDataGridComponent;
  public items: DataSource<any,any> = new DataSource<any,any>([]);
  public dropDownSelectedRow: any[] = [];
  public dropDownSelectedItemValue?: string;
  public gridItems: any[] = [];
  public gridSelectedRow: any[] = [];
  @Output() public changes = new EventEmitter();
  public selectedRowsData: any[] = [];
  public fromRemove = false;
  public isPhone: boolean = false;
  public role?: string;

  constructor(private screen: ScreenService, private renderer: Renderer2, private domService: DOMService) {
  }

  public populateGridData() {
    if (this.arr && this.selectedItemsKeys && !this.fromRemove) {
      this.gridItems = this.selectedRowsData;
      if (this.disableInEdit && this.selectedItemsRowsOnlyEdit && this.selectedItemsRowsOnlyEdit.length > 0) {
        const itemsNoAccess = this.selectedItemsRowsOnlyEdit.filter(x => this.selectedItemNoAccess.indexOf(x.id) === -1);
        const itemsToAdd = itemsNoAccess.filter(x => this.gridItems.map(y => y.id).indexOf(x.id) === -1);
        this.gridItems.push(...itemsToAdd);
      }
    }
  }

  public get GridSize() {
    const element = this.containerDiv?.nativeElement as HTMLElement;
    return element?.getBoundingClientRect().height -
      32 - element?.getBoundingClientRect().height;
  }

  public populateDropDownData() {
    if (this.arr && this.selectedItemsKeys) {
      this.items = new DataSource({ store: this.arr });
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedItemsKeys === undefined) {
      this.selectedItemsKeys = [];
    }
    this.populateDropDownData();

    if (changes.selectedItemsRowsOnlyEdit && changes.selectedItemsRowsOnlyEdit.currentValue !== undefined && changes.selectedItemsRowsOnlyEdit.currentValue.length > 0) {
      this.selectedRowsData = this.selectedItemsRowsOnlyEdit as any[];
      this.dropDownSelectedRow = [];
      this.dropDownSelectedRow.push(...this.selectedItemsKeys);
      this.populateGridData();
    }
  }

  public dropDownSelectionChanged(selection: any) {
    if (selection && selection.selectedRowsData.length > 0 && !this.fromRemove) {
      this.selectedRowsData = selection.selectedRowsData;
      this.dropDownSelectedItemValue = selection.selectedRowsData.map((row: any) => row[this.keyExpr]);
      /*if (typeof this.displayExpr === 'string') {
        this.dropDownSelectedItemValue = selection.selectedRowsData.map((s: any) => s[this.displayExpr as string]).join(', ');
      } else {
        let expression = '';
        selection.selectedRowsData.forEach((e: any) => {
          (this.displayExpr as string[]).forEach(t => expression += ` ${e[t]}`);
          expression += ',';
        });
        this.dropDownSelectedItemValue = expression;
      }*/
    } else {
      this.fromRemove = false;
      this.dropDownSelectedItemValue = undefined;
    }
  }

  public add() {
    this.selectedItemsKeys?.push(...this.dropDownSelectedRow);
    this.populateGridData();
    this.populateDropDownData();
    this.dropDownSelectedItemValue = undefined;
    this.changes.emit(this.gridItems);
  }

  public remove() {
    this.gridSelectedRow.forEach(row => {
      // @ts-ignore
      this.gridItems.splice(this.gridItems.findIndex(i => i[this.keyExpr] === row[this.keyExpr]), 1);
      // @ts-ignore
      this.selectedItemsKeys.splice(this.selectedItemsKeys.findIndex(i => i === row[this.keyExpr]), 1);

      this.fromRemove = true;
    });

    this.dropDownSelectedRow = [];
    this.dropDownSelectedRow.push(...(this.selectedItemsKeys?this.selectedItemsKeys:[]));
    this.populateGridData();
    this.populateDropDownData();
    this.changes.emit(this.gridItems);
  }

  public canRemove() {
    return this.gridSelectedRow.length > 0;
  }

  public ngOnInit(): void {
    if (this.grid)
      this.grid.height = this.GridSize;

    this.isPhone = this.screen.sizes['screen-x-small'];
    this.screen.changed.subscribe(() => {
      this.isPhone = this.screen.sizes['screen-x-small'];
    });
  }

  public resizePickerDropDown() {
    const element = this.domService.getElementsByClassname('dx-overlay-wrapper dx-dropdowneditor-overlay dx-popup-wrapper').item(0) as HTMLElement;
    if (element) {
      if (this.isPhone) {
        this.renderer.setStyle(element, 'width', '300px');
        this.renderer.setStyle(element.firstChild, 'width', '300px');
      } else {
        this.renderer.setStyle(element, 'width', '500px');
        this.renderer.setStyle(element.firstChild, 'width', '500px');
      }
      this.renderer.setStyle(element.firstChild, 'height', '38vh');
      this.renderer.setStyle(element.firstChild?.firstChild, 'height', '100%');
    }

    if (this.dropDownGrid !== undefined) {
      this.dropDownGrid.instance.clearFilter();
    }
  }

  public selectionChange(e: any) {
    if (this.disableInEdit && this.selectedItemsRowsOnlyEdit && this.selectedItemsRowsOnlyEdit.length > 0) {
      const disabledKeys = e.currentSelectedRowKeys.filter((i: any) => this.selectedItemNoAccess.indexOf(i.id) === -1);
      if (disabledKeys.length > 0) {
        e.component.deselectRows(disabledKeys);
      }
    }
  }

  public onRowPrepared(e: any) {
    if (this.disableInEdit && this.selectedItemsRowsOnlyEdit && this.selectedItemsRowsOnlyEdit.length > 0) {
      if (e.rowType === 'data' && e.data && this.selectedItemNoAccess.indexOf(e.data.id) === -1) {
        this.renderer.addClass(e.rowElement, 'disabled-row');
      }
    }
  }

  public onCellPrepared(e: any) {
    if (this.disableInEdit && this.selectedItemsRowsOnlyEdit && this.selectedItemsRowsOnlyEdit.length > 0) {
      if (e.rowType === 'data' && e.column.command === 'select' && !this.selectedItemNoAccess.includes(e.data.id)) {
        this.renderer.addClass(e.cellElement.firstChild, 'dx-state-disabled');
      }
    }
  }
}
